import React from 'react';
import Home from '../Home';
import Music from '../Music';
import MyContentContainer from '../MyContent';
import Stringray from '../Stringray';
import ActivesSingleton from "../../components/Header/ActivesSingleton";
import LoadingIptvOttFlow from '../../AAF/LoaderExp/LoadingIptvOttFlow';
import LayersControl from '../../utils/LayersControl';
import ClaroMusica from '../ClaroMusica';
import { IPTV, OTT } from '../../devices/all/settings';
import Mundial2026 from '../Mundial2026';
import logger from 'src/utils/logger/logger';


function NodeContent(props) {
  const code = props.match.params.code;
  const tv_node = new ActivesSingleton().getTvNode();
  const nodes = props.nodes;
  let app_behaviour = null;
  //Ahora ya no se toma el code para redirigir a tv, ahora se toma app_behaviour
  let currentNode = [];

  const findNode = (node) => {
    if (node.code === code) {
      currentNode = node;
    } else if (node.childs && node.childs.forEach) {
      node.childs.forEach(findNode);
    }
  };

  nodes.forEach(findNode);

  if (currentNode && currentNode.app_behaviour && currentNode.app_behaviour !== null) {
    app_behaviour = JSON.parse(currentNode.app_behaviour);
    //console.log('**** app_behaviour ****', app_behaviour);

    if (app_behaviour && app_behaviour.layout === 'guidechannels') {
      logger.debug('***** Aqui se debe redirigir a TV *******');
      return null;
    }
  }
  const { type = OTT } = props.user;
  const isIPTV = type === IPTV;

  if(LoadingIptvOttFlow.isToogleLevelsDelay() && code !== tv_node && LoadingIptvOttFlow.isEnableRibbons() === undefined && !LayersControl.isPlayerVisible() && isIPTV){
    LoadingIptvOttFlow.setIsEnabled(true);
  }

  switch (code) {
    case 'claromusica':
    case 'claromusica_inicio':
      return <Music code={code} nodes={nodes} />;
    case 'claromusica_listas':
    case 'claromusica_radios':
    case 'claromusica_mimusica':
      return <ClaroMusica />;
    case 'misgrabaciones':
      return <MyContentContainer code={code} />;
    case 'claromusica_stringray':
    case 'claromusica_stingray':
      return <Stringray />;
    default:
      return <Home
        history={props.history}
        code={code}
        appBehaviour={app_behaviour}
        updateFavoriteVOD={props.updateFavoriteVOD}
        updateFavoriteChannels={props.updateFavoriteChannels}
        nodes = {nodes}
        loadLinealChannels = {props.loadLinealChannels}
      />;
  }
}

export default NodeContent;



// WEBPACK FOOTER //
// ./src/containers/NodeContent/index.jsx